<template>
  <main class="pt-4 mx-0 mb-50px">
    <div class="d-flex flex-row justify-content-between align-items-center mb-4">
      <h1>
        {{ $t('Transport') }}
      </h1>
      <dx-button
        :text="$t('Add transport')"
        icon="ace-icon icon-plus"
        type="success"
        styling-mode="contained"
        class="custom-btn"
      />
    </div>
    <dx-data-grid
      ref="fileGrid"
      :data-source="transportDataSource"
      :show-column-headers="true"
    >
      <dx-column
        data-field="description"
        :caption="$t('description')"
        :allow-search="false"
      />
      <dx-column
        data-field="description_en"
        :caption="$t('description_en')"
        :allow-search="false"
      />

      <dx-editing
        :allow-deleting="true"
        :allow-updating="true"
        :allow-adding="true"
        :use-icons="true"
        mode="row"
      />
    </dx-data-grid>
    <!-- </b-col> -->
  </main>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
} from 'devextreme-vue/data-grid';

import { DxButton } from 'devextreme-vue';
import createCustomStore from '@/utils/create-custom-store';


export default {
  name: 'Transport',
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxButton,
  },
  data() {
    return {
      transportDataSource: createCustomStore('service/api/transport_kind/'),
    };
  },
};
</script>
